import React from "react";
import {
  Divider,
  ListItemIcon,
  ListItemText,
  MenuList,
  Paper,
  Tooltip,
  // Typography,
} from "@common-ui/ui";
import { IconButton, Menu, MenuItem } from "@common-ui/ui";
import {
  MoreHoriz,
  Add,
  Edit,
  Abc,
  DeleteForever,
  Login,
} from "@mui/icons-material";
import { useHistory } from "react-router-dom";
const AddChild = ({ handleClick, nodeId }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  let router = useHistory();
  const open = Boolean(anchorEl);
  const handleClickListItem = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    // setSelectedIndex(index);
    event.stopPropagation();
    if (index === 2) {
      return router.push(`/orgs/${nodeId}/edit`);
    }
    return router.push(`/create-sub-org/${nodeId}`);
    // handleClick(index);
    // setAnchorEl(null);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <span>
      <Tooltip title="More actions">
        <IconButton
          size="small"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClickListItem}
        >
          <MoreHoriz size="small" />
        </IconButton>
      </Tooltip>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
      >
        <Paper sx={{ width: 320, maxWidth: "100%" }}>
          <MenuList>
            <MenuItem
              onClick={(event) => {
                handleMenuItemClick(event, 1);
              }}
            >
              <ListItemIcon>
                <Add fontSize="small" />
              </ListItemIcon>
              <ListItemText>Create a sub organization</ListItemText>
              {/* <Typography variant="body2" color="text.secondary">
                ⌘C
              </Typography> */}
            </MenuItem>
            <Divider />
            <MenuItem
              // disabled
              onClick={(event) => {
                // handleAddSubPlace(nodeId);
                handleMenuItemClick(event, 2);
              }}
            >
              <ListItemIcon>
                <Edit fontSize="small" />
              </ListItemIcon>
              <ListItemText>Edit organization details</ListItemText>
              {/* <Typography variant="body2" color="text.secondary">
                ⌘C
              </Typography> */}
            </MenuItem>
            <MenuItem
              disabled
              onClick={(event) => {
                // handleAddSubPlace(nodeId);
                handleMenuItemClick(event, 3);
              }}
            >
              <ListItemIcon>
                <Abc fontSize="small" />
              </ListItemIcon>
              <ListItemText>Rename organization</ListItemText>
              {/* <Typography variant="body2" color="text.secondary">
                ⌘V
              </Typography> */}
            </MenuItem>
            <MenuItem
              onClick={(event) => {
                // handleAddSubPlace(nodeId);
                window?.localStorage.setItem(
                  "CURRENT_ORGANIZATION",
                  JSON.stringify(nodeId)
                );
                handleClose(event);
                // handleMenuItemClick(event, 4);
              }}
            >
              <ListItemIcon>
                <Login fontSize="small" />
              </ListItemIcon>
              <ListItemText>Login to this Organization</ListItemText>
              {/* <Typography variant="body2" color="text.secondary">
                ⌘V
              </Typography> */}
            </MenuItem>
            <Divider />
            <MenuItem disabled>
              <ListItemIcon>
                <DeleteForever fontSize="small" />
              </ListItemIcon>
              <ListItemText>Remove</ListItemText>
            </MenuItem>
          </MenuList>
        </Paper>
        {/* {options.map((option, index) => (
          <MenuItem
            key={option}
            selected={index === selectedIndex}
            onClick={(event) => {
              // handleAddSubPlace(nodeId);
              handleMenuItemClick(event, index);
            }}
          >
            {option.name}
          </MenuItem>
        ))} */}
      </Menu>
    </span>
  );
};

export default AddChild;
